import { render, staticRenderFns } from "./packageTableExpand.vue?vue&type=template&id=5191e385&scoped=true&"
import script from "./packageTableExpand.vue?vue&type=script&lang=js&"
export * from "./packageTableExpand.vue?vue&type=script&lang=js&"
import style0 from "./packageTableExpand.vue?vue&type=style&index=0&id=5191e385&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191e385",
  null
  
)

export default component.exports